import { motion } from "framer-motion";

export default function ArrowView() {
	return (
		<motion.div
			animate={{
				y: [0, 15, 0],
			}}
			transition={{
				duration: 1.24,
				repeat: Infinity,
				ease: "easeInOut",
			}}
			className="text-center mb-4"
		>
			<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
				<g clipPath="url(#clip0_4836_4346)">
					<path
						d="M14 27.2779C21.3332 27.2779 27.2779 21.3332 27.2779 14C27.2779 6.66687 21.3332 0.722168 14 0.722168C6.66687 0.722168 0.722168 6.66687 0.722168 14C0.722168 21.3332 6.66687 27.2779 14 27.2779Z"
						stroke="white"
						strokeWidth="1.5"
						strokeMiterlimit="10"
					/>
					<path
						d="M19.8445 13.0852L13.9999 18.0921L8.14575 13.0852"
						stroke="white"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</g>
				<defs>
					<clipPath id="clip0_4836_4346">
						<rect width="28" height="28" fill="white" />
					</clipPath>
				</defs>
			</svg>
		</motion.div>
	);
}
